import { z } from "zod";
import { IsoDateTimeSchema, StableIdSchema } from "./common.js";

export const OwnerUserSchema = z
  .object({
    id: StableIdSchema,
    displayName: z.string().min(1).max(80),
    role: z.literal("owner"),
  })
  .strict();

export const LoginRequestSchema = z
  .object({
    username: z.string().trim().min(1).max(80),
    password: z.string().min(1).max(1024),
  })
  .strict();

export const AuthenticatedSessionSchema = z
  .object({
    authenticated: z.literal(true),
    user: OwnerUserSchema,
    expiresAt: IsoDateTimeSchema,
  })
  .strict();

export const AnonymousSessionSchema = z
  .object({
    authenticated: z.literal(false),
    user: z.null(),
  })
  .strict();

export const AuthSessionSchema = z.discriminatedUnion("authenticated", [
  AuthenticatedSessionSchema,
  AnonymousSessionSchema,
]);

/** 登录成功响应的稳定命名，供 BFF route 与客户端共同引用。 */
export const LoginResponseSchema = AuthenticatedSessionSchema;

export const LogoutResponseSchema = z.object({ ok: z.literal(true) }).strict();

export type OwnerUser = z.infer<typeof OwnerUserSchema>;
export type LoginRequest = z.infer<typeof LoginRequestSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
export type AuthenticatedSession = z.infer<typeof AuthenticatedSessionSchema>;
export type AuthSession = z.infer<typeof AuthSessionSchema>;
export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
